module.exports = __webpack_public_path__ + "img/Official.4f7015e0.svg";